import { h } from "preact";
import { renderPage } from "./renderPage";
import { Home } from "./components/pages/home";

const itemMatcher = /^\/item\/([0-9]+)\/?$/;

function renderHome(args: any) {
    renderPage(h(Home, { savedState: args }));
}

export function navigateTo(to: string, args: any, doPushState: boolean = true) {
    return (evt: MouseEvent | null) => {
        if (evt) {
            if (evt.ctrlKey) {
                return;
            }
            evt.preventDefault();
        }
        if (doPushState) {
            history.pushState(args, "", to);
        }
        if (to === "/") {
            renderHome(args);
        } else if (itemMatcher.test(to)) {
            import("./components/pages/item").then((component) => {
                if (args && args.item) {
                    renderPage(h(component.default, { item: args.item, itemId: args.item.id, itemKids: null }));
                } else {
                    const matches = itemMatcher.exec(to);
                    if (!matches || matches.length < 2) {
                        renderHome(args);
                        return;
                    }
                    renderPage(h(component.default, { item: null, itemId: parseInt(matches[1], 10), itemKids: null }));
                }
            });
        } else {
            // TODO: I suspect this breaks the back button if you are linked from another origin
            renderHome(args);
        }
    }
}
